import { PartialCarConfiguration } from '~/app/market-config/models/car-confi-market-configuration';
import { PartialUiConfiguration } from '~/app/market-config';

const q3: PartialCarConfiguration = {
	combinations: [
		'trimLine',
		'equipmentPackages',
		'packages',
		'paint',
		'rims',
		'headlights',
		'interiorPackages',
		'steeringWheels',
	],
};

const q3ehybrid: PartialCarConfiguration = {
	...q3,
};

const q3_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

const q3ehybrid_ui: PartialUiConfiguration = {
	showAccessoriesInclusive: false,
};

export { q3, q3ehybrid, q3_ui, q3ehybrid_ui };
